function captions(text) {
  text = text.replace(/\n/, '')
  let captionsBox = document.querySelector('#cc-box')
  let captionsNode = captionsBox.querySelector('p')
  captionsNode.innerText = text
  if(text === '') {
    captionsBox.classList.add('empty')
  }
  else {
    captionsBox.classList.remove('empty')
  }
}

function cueVideoCaptions(video, captionList) {
  let keys = Object.keys(captionList)
  function cue() {
    for(let i = 0; i < keys.length; i++) {
      captionIterator(i)
    }
    function captionIterator(i) {
      const key = keys[i]
      const time = parseInt(key)
      const videoTime = Math.round(video.currentTime * 1000)
      if(videoTime > time) {
        captions( captionList[key] )
        if( i === keys.length - 1 ) {
          clearInterval(interval)
        }
        else {
          return
        }
      }
    }
  }
  let interval = setInterval(cue, 50)
}

export {captions, cueVideoCaptions}
